import React, { useState } from "react";
import "./NewTask.scss";

function NewTask({ handleKeyDown }) {
  const [taskTitle, setTaskTitle] = useState("");

  const handleChange = (e) => {
    setTaskTitle(e.target.value);
  };

  const handleKeyDownWithReset = (e) => {
    handleKeyDown(e);
    if (e.key === "Enter") {
      setTaskTitle("");
    }
  };
  return (
    <div className="task-input">
      <input
        type="text"
        placeholder="New task..."
        onKeyDown={handleKeyDownWithReset}
        className="new-task-input"
        value={taskTitle}
        onChange={handleChange}
      />
    </div>
  );
}

export default NewTask;
